import { Box, styled } from '@material-ui/core';

export const FormContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 24,
  paddingLeft: 24,
  paddingRight: 24,
});

export const helperTextErrorStyle = {
  color: '#CB3412',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '22.4px',
};

export const Title = styled('h2')({
  color: '#163258',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 24,
  fontWeight: 700,
  lineHeight: '32px',
  margin: 0,
  marginBottom: 8,
});

export const Subtitle = styled('p')({
  color: '#163258',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 18,
  fontWeight: 400,
  lineHeight: '135%',
  margin: 0,
  marginBottom: 16,
});

export const CheckboxContainer = styled(Box)({
  margin: 16,
});

export const CheckboxLabel = styled('span')({
  color: '#363334',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '135%',
  alignSelf: 'stretch',
});

export const MarketingConsentLabel = styled('span')({
  color: '#202625',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '135%',
  alignSelf: 'stretch',
});

export const SubmitButtonWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 8,
  marginBottom: 24,
});

export const inputLabelStyle = {
  color: '#6A717D',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '18px',
};

export const inputStyle = {
  color: '#363334',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 16,
  fontWeight: 500,
  lineHeight: '24px',
  '&::placeholder': {
    color: '#989BA4',
    fontFamily: '"GT Walsheim", sans-serif',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    opacity: 1,
  },
};

export const checkboxStyle = {
  width: 18,
  height: 18,
  borderRadius: 4,
  marginRight: 12,
  marginTop: 6,
  color: '#067B65',
  '&.Mui-checked': {
    color: '#067B65',
  },
};

export const submitButtonStyle = {
  width: 235,
  height: 56,
  padding: '16px 24px',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '135%',
  borderRadius: 56,
};
